import Vue from 'vue'
import Router from 'vue-router'
import multiguard from 'vue-router-multiguard'
import TopupStartView from './views/TopupStartView'
import TopupSingleView from './views/TopupSingleView'
import TopupAutoView from './views/TopupAutoView'
import CreditCardView from '@/plus/views/CreditCardView'
import CreditCardBackView from '@/plus/views/CreditCardBackView'
import TopupBack from './views/TopupBack'
import Contacts from './views/Contacts'
import ContactsEditView from './views/ContactsEditView'
import History from './views/History'
import UserData from './views/UserData'
import Unregister from './views/Unregister'
import UserTerms from './views/UserTerms'
import { ROUTING } from './const/routing.const'
import {
  LoggedAutotopupGuard,
  LoggedGuard, PaymentBlikNotSetGuard,
  PaymentNotSetGuard, userTermsNotSetGuard,
  userTermsRequiredGuard
} from '@/common/guards/user.guard'
import BlikView from '@/plus/views/BlikView.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: ROUTING.main,
      name: 'home',
      component: TopupStartView,
      beforeEnter: multiguard([userTermsRequiredGuard, LoggedAutotopupGuard])
    },
    {
      path: ROUTING.singleTopup,
      name: 'singleTopup',
      component: TopupSingleView,
      props: true,
      beforeEnter: userTermsRequiredGuard
    },
    {
      path: ROUTING.autoTopup,
      name: 'autoTopup',
      component: TopupAutoView,
      beforeEnter: multiguard([userTermsRequiredGuard, LoggedAutotopupGuard]),
      props: true
    },
    {
      path: ROUTING.back,
      name: 'back',
      component: TopupBack
    },
    {
      path: ROUTING.unregister,
      name: 'unregister',
      component: Unregister
    },
    {
      path: ROUTING.contacts,
      name: 'contacts',
      component: Contacts,
      beforeEnter: multiguard([LoggedGuard, userTermsRequiredGuard])
    },
    {
      path: ROUTING.contactEdit + '/:id',
      name: 'contactEdit',
      component: ContactsEditView,
      beforeEnter: multiguard([LoggedGuard, userTermsRequiredGuard]),
      props: true
    },
    {
      path: ROUTING.history,
      name: 'history',
      component: History,
      beforeEnter: multiguard([LoggedGuard, userTermsRequiredGuard])
    },
    {
      path: ROUTING.userData,
      name: 'userData',
      component: UserData,
      beforeEnter: multiguard([LoggedGuard, userTermsRequiredGuard])
    },
    {
      path: ROUTING.blik,
      name: 'blik',
      component: BlikView,
      beforeEnter: multiguard([LoggedGuard, userTermsRequiredGuard, PaymentBlikNotSetGuard])
    },
    {
      path: ROUTING.creditCard,
      name: 'creditCard',
      component: CreditCardView,
      beforeEnter: multiguard([LoggedGuard, userTermsRequiredGuard, PaymentNotSetGuard])
    },
    {
      path: ROUTING.backCreditCard,
      name: 'creditCardBack',
      component: CreditCardBackView
    },
    {
      path: ROUTING.userAccountTerms,
      name: 'userTerms',
      component: UserTerms,
      beforeEnter: multiguard([LoggedGuard, userTermsNotSetGuard])
    },
    {
      path: '*',
      redirect: ROUTING.main
    }
  ]
})
